import {createTheme} from "@mui/material/styles";
import {frFR,enUS} from '@mui/material/locale';

let theme = createTheme({
	palette: {
		primary: {
			main: '#B1B7AA',
			dark: '#62757c',
			light: '#D2D6C9'
		},
		secondary: {
			main: '#ccafad',
			light: '#cccccc',
			dark: '#abb4b7'
		},
	},
	frFR,
	enUS
})

theme = createTheme(theme, {
	typography: {
		h1:{
			fontFamily: '"DM Serif Display", "Roboto", "Arial", sans-serif',
			color: theme.palette.primary.dark,
			[theme.breakpoints.down('md')]: {
				fontSize: '2.5rem'
			},
		},
		h2:{
			fontFamily: '"DM Serif Display", "Roboto", "Arial", sans-serif',
			color: theme.palette.primary.dark,
			[theme.breakpoints.down('md')]: {
				fontSize: '2.1rem'
			},
		},
		h3:{
			fontFamily: '"DM Serif Display", "Roboto", "Arial", sans-serif',
			color: theme.palette.primary.dark,
		},
		h4:{
			fontFamily: '"DM Serif Display", "Roboto", "Arial", sans-serif',
			color: theme.palette.primary.dark,
		},
		h5:{
			fontSize: '2rem',
			fontFamily: '"DM Serif Display", "Roboto", "Arial", sans-serif',
			color: theme.palette.primary.dark,
			[theme.breakpoints.down('md')]: {
				fontSize: '1.5rem'
			},
		},
		h6:{
			fontFamily: '"DM Serif Display", "Roboto", "Arial", sans-serif',
			color: theme.palette.primary.dark,
		},
		body1:{
			fontSize: '1.2rem',
		},
		body2:{
			fontSize: '1.2rem',
		}
	},
	components: {
		Mui:{
			styleOverrides:{
				focuses: {
					borderColor:'Black',
				}
			}
		},
		MuiButton: {
			styleOverrides:{
				root: {
					backgroundColor: theme.palette.primary.main,
				},
				containedPrimary: {
					"&:hover": {
						backgroundColor: theme.palette.secondary.main
					},
					[theme.breakpoints.down('md')]: {
						fontSize: '1rem'
					},

				},
				containedSecondary: {
					backgroundColor: theme.palette.secondary.dark,
					"&:hover": {
						backgroundColor: theme.palette.secondary.light,
					}
				},
			},
		},
		MuiLink:{
			styleOverrides: {
				root: {
					cursor: 'pointer',
				},

				underlineHover: {
					"&:hover": {
						color: '#abb4b7'
					}
				}
			}
		},
		MuiTextField:{
			styleOverrides:{
				root:{
					margin: theme.spacing(2),
					marginLeft: 0,
				},
			}
		},
	},
})

export default theme